import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["for", "id"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_3 = ["name", "id", "placeholder"]

import { ref, onMounted, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MyTags',
  props: {
    modelValue: {},
    name: {},
    placeholder: {},
    value: {},
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const tags = ref<string[]>(props.modelValue || props.value || [])

watch(() => props.modelValue, (newValue) => {
  tags.value = newValue || []
  renderTags()
})
const inputVal = ref<string>('')

const renderTags = () => {
  const tagTarget = document.querySelector(`#${props.name}-input span`)
  if (tagTarget) {
    tagTarget.innerHTML = ''
    tags.value.forEach((tag) => {
      const tagElement = constructTag(tag)
      tagTarget.appendChild(tagElement)
    })
  }
}

const constructTag = (tag: string) => {
  const elem = document.createElement('span')
  elem.classList.add('tag')
  elem.innerText = tag.trim()
  elem.dataset.tag = tag

  if (!props.disabled) {
    const close = document.createElement('a')
    close.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M15 5L5 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M5 5L15 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`
    close.classList.add('close')
    close.href = '#'
    close.dataset.tag = tag
    close.addEventListener('click', removeTag)

    elem.appendChild(close)
    elem.addEventListener('click', togglePopOverEdit)
  }

  return elem
}

const addTag = (tagName: string) => {
  if (tagName.trim() === '' || checkDuplication(tagName)) {
    return
  }
  tags.value.push(tagName.toLowerCase())
  renderTags()
  emit('update:modelValue', tags.value)
}

const bindOnChange = (e: Event) => {
  const input = e.target as HTMLInputElement
  const val = input.value
  const lastChar = val.substr(val.length - 1)

  if (lastChar === ',') {
    const tagName = val.replace(',', '').trim()
    input.value = ''
    inputVal.value = ''
    addTag(tagName)
  }
}

const handleKeyPress = (e: KeyboardEvent) => {
  const input = e.target as HTMLInputElement
  if (e.key === 'Enter') {
    e.preventDefault()
    const tagName = input.value.trim()
    if (tagName !== '') {
      addTag(tagName)
      input.value = ''
      inputVal.value = ''
    }
  }
}

const checkDuplication = (tag: string) => tags.value.includes(tag)

const checkBackspaceOnEmpty = (e: KeyboardEvent) => {
  if (tags.value.length > 0 && (e.key === 'Backspace' || e.key === 'Delete')) {
    const input = e.target as HTMLInputElement
    if (input.value === '') {
      const lastVal = tags.value.pop()
      if (lastVal) {
        input.value = lastVal + ' '
        renderTags()
      }
    }
  }
}

const removeTag = (e: any) => {
  e.preventDefault()
  const target = e.currentTarget as HTMLAnchorElement
  const tagToRemove = target.dataset.tag || ''
  const index = tags.value.indexOf(tagToRemove)

  if (index > -1) {
    tags.value.splice(index, 1)
    renderTags()
  }
}

const togglePopOverEdit = (e: Event) => {
  const target = e.currentTarget as HTMLElement
  const hasPopOver = target.querySelector('#pop-over-edit')
  const popOver = document.createElement('div')
  const popOverInput = document.createElement('input')

  if (hasPopOver) {
    target.removeChild(hasPopOver)
    return
  }

  if (!hasPopOver && target.nodeName === 'SPAN') {
    const curValue = target.dataset.tag || ''
    popOverInput.value = curValue
    popOver.setAttribute('id', 'pop-over-edit')
    popOverInput.setAttribute('name', 'tag-edit')
    popOverInput.setAttribute('id', 'tag-edit')
    popOverInput.addEventListener('input', (e: Event) => {
      bindPopOverInput(e, curValue)
    })

    popOver.appendChild(popOverInput)
    target.appendChild(popOver)
  }
}

const bindPopOverInput = (e: Event, tag: string) => {
  const input = e.target as HTMLInputElement
  const val = input.value
  const index = tags.value.indexOf(tag)

  if (val !== '') {
    if (index > -1) {
      tags.value[index] = val
      const tagElement = document.querySelector(`.tag[data-tag="${tag}"]`) as HTMLElement
      if (tagElement) {
        tagElement.innerText = val
        tagElement.dataset.tag = val
      }
    }
  } else {
    removeTag({ currentTarget: { dataset: { tag } } })
  }
}

onMounted(() => {
  const inputTarget = document.querySelector(`#${props.name}`) as HTMLInputElement
  if (inputTarget) {
    inputTarget.addEventListener('input', bindOnChange)
    inputTarget.addEventListener('keydown', handleKeyPress)
    inputTarget.addEventListener('keydown', checkBackspaceOnEmpty)
  }
  renderTags()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: "tag-input",
    for: _ctx.name,
    id: `${_ctx.name}-input`
  }, [
    _hoisted_2,
    (!_ctx.disabled)
      ? _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 0,
          name: _ctx.name,
          id: _ctx.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputVal).value = $event)),
          onInput: bindOnChange,
          onKeydown: checkBackspaceOnEmpty,
          placeholder: _ctx.placeholder
        }, null, 40, _hoisted_3)), [
          [_vModelText, inputVal.value]
        ])
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})